<template>
  <div>
  <div
  class="modal fade"
  id="myModal"
  tabindex="-1"
  aria-labelledby="getInTouchModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow">
      <!-- Modal Header -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="getInTouchModalLabel">
          <i class="fa fa-phone"></i> Contact Us
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body text-center">
        <h6 class="mb-3 text-secondary">
          <i class="fa fa-building"></i> Business Enquiries
        </h6>
        <p class="mb-4">
          <i class="fa fa-phone"></i> +91-9655801691
        </p>
        <h6 class="mb-3 text-secondary">
          <i class="fa fa-th-large"></i> Tile Enquiries
        </h6>
        <p>
          <i class="fa fa-phone"></i> +91-9677446317
        </p>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer bg-light">
        <button
          type="button"
          class="btn btn-outline-primary"
          data-bs-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
    <!-- First Navigation Bar -->
    <nav class="navbar navbar-expand-xl navbar-light navbar-custom-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img src="@/assets/logo.png" class="logo" alt="Ganesh Tiles Logo" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          @click="toggleOffcanvas('first')"
          aria-controls="offcanvasNavbarFirst"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item mx-3">
              <a class="nav-link" href="#">About Us</a>
            </li>
           
            <li class="nav-item mx-3">
              <a class="nav-link" href="#">Get In Touch</a>
            </li>
          </ul>
          <div class="d-flex">
          <a href="tel:7092550000" class="btn btn-custom mx-1">Business: </a>
          <a href="tel:8111022222" class="btn btn-custom mx-1">Tile Enquiry: </a>
        </div>
        </div>
      </div>
    </nav>

    <!-- Offcanvas for First Navigation Bar -->
    <div
      ref="offcanvasFirst"
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="offcanvasNavbarFirst"
      aria-labelledby="offcanvasNavbarFirstLabel"
    >
      <div class="offcanvas-header">
        <a class="navbar-brand" href="#">
          <img src="@/assets/logo.png" class="logo" alt="Ganesh Tiles Logo" />
        </a>
        <button
          type="button"
          class="btn-close"
          @click="toggleOffcanvas('first')"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav">
           <li class="nav-item">
          <a class="nav-link" href="#">About Us</a>
        </li>
        
     
        <li class="nav-item">
          <a class="nav-link" href="#" @click="openModal">Get In Touch</a>
        </li>
        </ul>
      </div>
    </div>

    <!-- Second Navigation Bar -->
     <nav class="navbar navbar-expand-xl  navbar-dark navbar-custom-dark ">
      <div class="container-fluid">
       
        <button
          class="navbar-toggler"
          type="button"
          @click="toggleOffcanvas('second')"
          aria-controls="offcanvasNavbarSecond"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse">
          <ul class="navbar-nav mb-2 mb-lg-0">
          <li class="nav-item">
               <router-link to="/home" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas();}"
    >
      <i class="fa fa-home"></i> Home
    </a>
  </template>
</router-link>
           
          </li>
          <li class="nav-item position-relative" @mouseover="showMegaMenu = true" @mouseleave="showMegaMenu = false">
              <a class="nav-link" href="#"><i class="fa fa-th"></i> Tiles</a>
              <!-- Mega Menu -->
              <div v-if="showMegaMenu" class="mega-menu">
                <div class="container-fluid">
                  <div class="row">
                    <!-- Display categories -->
                    <div class="col-md-2 mega-menu-item">
                      <h5>Categories</h5>
                      <ul class="mega-menu-list">
                        <li v-for="category in categories" :key="category.category_id" @click="navigateToCategory(category)">
                          <span>{{ category.category_name }}</span>
                        </li>
                      </ul>
                    </div>
                    <!-- Display other menu items -->
                    <div class="col-md-2 mega-menu-item">
                      <h5>Size</h5>
                      <ul class="mega-menu-list">
                        <li v-for="size in sizes" :key="size.size_id" @click="navigateToSize(size)">{{ size.size_name }}</li>
                      </ul>
                    </div>
                    <div class="col-md-2 mega-menu-item">
                      <h5>Where to Use</h5>
                      <ul class="mega-menu-list">
                        <li v-for="use in whereToUse" :key="use.where_to_use_id" @click="navigateToWhereTouse(use)">{{ use.where_to_use_name }}</li>
                      </ul>
                    </div>
                    <div class="col-md-2 mega-menu-item">
                      <h5>Material</h5>
                      <ul class="mega-menu-list">
                        <li v-for="material in materials" :key="material.material_id" @click="navigateToMaterial(material)">{{ material.material_name }}</li>
                      </ul>
                    </div>
                    <div class="col-md-2 mega-menu-item">
                      <h5>Surface Finish</h5>
                      <ul class="mega-menu-list">
                        <li v-for="finish in surfaceFinishes" :key="finish.surface_finish_id" @click="navigateToSurfaceFinish(finish)">{{ finish.surface_finish_name }}</li>
                      </ul>
                    </div>
                    <div class="col-md-2 mega-menu-item">
                      <h5>Color</h5>
                      <ul class="mega-menu-list">
                        <li v-for="color in colors" :key="color.color_id" @click="navigateToColor(color)">{{ color.color_name }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          <li class="nav-item">
             <router-link to="/sanitarware" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-bath"></i> Sanitaryware
    </a>
  </template>
</router-link>
          </li>
          
          <li class="nav-item">
               <router-link to="/faucet" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-tint"></i> Faucet
    </a>
  </template>
</router-link>
          </li>
          <li class="nav-item">
             <router-link to="/Granites" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-diamond"></i> Granites
    </a>
    </template>
</router-link>
          </li>
          
          <li class="nav-item">
            <router-link to="/kitchenSink" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-cutlery"></i> Kitchen Sink
    </a>
    </template>
</router-link>
          </li>
          
          <li class="nav-item">
            <router-link to="/FlushTank" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-recycle"></i> Flush Tank
    </a>
    </template>
</router-link>
          </li>
        </ul>
        </div>
      </div>
    </nav>

    <!-- Offcanvas for Second Navigation Bar -->
    <div
      ref="offcanvasSecond"
      class="offcanvas offcanvas-start"
      tabindex="-1"
      id="offcanvasNavbarSecond"
      aria-labelledby="offcanvasNavbarSecondLabel"
    >
      <div class="offcanvas-header">
        <img src="@/assets/logo.png" class="logo" alt="Ganesh Tiles Logo" />
        <button
          type="button"
          class="btn-close"
          @click="toggleOffcanvas('second')"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <ul class="navbar-nav">
          <li class="nav-item">
              <router-link to="/home" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas();}"
    >
      <i class="fa fa-home"></i> Home
    </a>
  </template>
</router-link>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="#"
              @click.prevent="toggleSubcategories"
            >
              <i class="fa fa-th"></i> Tiles
            </a>
            <!-- Accordion inside offcanvas -->
            <div
              v-if="showSubcategories"
              class="accordion mt-2"
              id="tilesAccordion"
            >
            <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#Categories"
                  >
                    Categories
                  </button>
                </h2>
                <div
                  id="Categories"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"> <ul class="mega-menu-list">
                        <li v-for="category in categories" :key="category.category_id" @click="navigateToCategory(category)">
                          <span>{{ category.category_name }}</span>
                        </li>
                      </ul>
                      </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#Size"
                  >
                    Size
                  </button>
                </h2>
                <div
                  id="Size"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"> <ul class="mega-menu-list">
                        <li v-for="size in sizes" :key="size.size_id" @click="navigateToSize(size)">{{ size.size_name }}</li>
                      </ul>
                      </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#WheretoUse"
                  >
                   Where to Use
                  </button>
                </h2>
                <div
                  id="WheretoUse"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"><ul class="mega-menu-list">
                        <li v-for="use in whereToUse" :key="use.where_to_use_id" @click="navigateToWhereTouse(use)">{{ use.where_to_use_name }}</li>
                      </ul>
                      </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#Material"
                  >
                    Material
                  </button>
                </h2>
                <div
                  id="Material"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"><ul class="mega-menu-list">
                        <li v-for="material in materials" :key="material.material_id" @click="navigateToMaterial(material)">{{ material.material_name }}</li>
                      </ul>
                      </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#SurfaceFinish"
                  >
                    Surface Finish
                  </button>
                </h2>
                <div
                  id="SurfaceFinish"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"> <ul class="mega-menu-list">
                        <li v-for="finish in surfaceFinishes" :key="finish.surface_finish_id" @click="navigateToSurfaceFinish(finish)">{{ finish.surface_finish_name }}</li>
                      </ul>
                      </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#Color"
                  >
                   Color
                  </button>
                </h2>
                <div
                  id="Color"
                  class="accordion-collapse collapse"
                  data-bs-parent="#tilesAccordion"
                >
                  <div class="accordion-body"><ul class="mega-menu-list">
                        <li v-for="color in colors" :key="color.color_id" @click="navigateToColor(color)">{{ color.color_name }}</li>
                      </ul>
                      </div>
                </div>
              </div>
            </div>
          </li>
        

          <li class="nav-item">
             <router-link to="/sanitarware" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-bath"></i> Sanitaryware
    </a>
  </template>
</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/faucet" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-tint"></i> Faucet
    </a>
  </template>
</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/Granites" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-diamond"></i> Granites
    </a>
    </template>
</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/kitchenSink" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-cutlery"></i> Kitchen Sink
    </a>
    </template>
</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/FlushTank" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-recycle"></i> Flush Tank
    </a>
    </template>
</router-link>
          </li>
        </ul>
      </div>
    </div>
  
     <router-view />
     
  <footer class="footer-section">
  <div class="container">
    <div class="row">
      <!-- About Us -->
      <div class="col-lg-4 col-md-6">
        <h5 class="footer-title">About Us</h5>
        <p class="footer-description">
          Explore our range of tiles, sanitaryware, faucets, granites, kitchen sinks, and flush tanks. Quality craftsmanship for your home and business needs.
        </p>
      </div>

      <!-- Quick Links -->
      <div class="col-lg-4 col-md-6">
        <h5 class="footer-title">Quick Links</h5>
        <ul class="footer-links">
          <li>
            <router-link to="/home" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas();}"
    >
      <i class="fa fa-home"></i> Home
    </a>
  </template>
</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TilesCategory', params: { category_id: 2, category_name: 'Floor Tiles' } }" custom>
              <template v-slot="{ href, navigate }">
                <a :href="href" class="nav-link" @click="() => { navigate(); handleOffcanvas(); }">
                  <i class="fa fa-th"></i> Tiles
                </a>
              </template>
            </router-link>
          </li>
          <li>
             <router-link to="/sanitarware" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-bath"></i> Sanitaryware
    </a>
  </template>
</router-link>
          </li>
          <li>
             <router-link to="/faucet" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-tint"></i> Faucet
    </a>
  </template>
</router-link>
          </li>
          <li>
              <router-link to="/Granites" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-diamond"></i> Granites
    </a>
    </template>
</router-link>
          </li>
          <li>
           <router-link to="/kitchenSink" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-cutlery"></i> Kitchen Sink
    </a>
    </template>
</router-link>
          </li>
          <li>
              <router-link to="/FlushTank" custom>
  <template v-slot="{ href, navigate }">
    <a
      :href="href"
      class="nav-link"
      @click="() => { navigate(); handleOffcanvas(); }"
    >
      <i class="fa fa-recycle"></i> Flush Tank
    </a>
    </template>
</router-link>
          </li>
          
        </ul>
      </div>

      <!-- Contact Us -->
      <div class="col-lg-4 col-md-12">
        <h5 class="footer-title">Contact Us</h5>
        <p class="footer-contact">
          <strong>Business Enquiries:</strong> 
          <a href="tel:+919876543210">+91-9876543210</a><br />
          <strong>Tile Enquiries:</strong> 
          <a href="tel:+919876543211">+91-9876543211</a><br />
          <strong>Email:</strong> 
          <a href="mailto:info@example.com">info@example.com</a>
        </p>
        <div class="footer-social">
          <a href="#" class="social-icon"><i class="fa fa-facebook"></i></a>
          <a href="#" class="social-icon"><i class="fa fa-instagram"></i></a>
          <a href="#" class="social-icon"><i class="fa fa-linkedin"></i></a>
        </div>
      </div>
    </div>
  </div>
</footer>


</div>
 
</template>


<script>
import baseURL from "@/api/config.js";
import { Modal } from 'bootstrap';
import { Offcanvas } from "bootstrap";
import eventBus from '@/eventBus'; // ✅ Correct Import
export default {
  data() {
    return {
      showMegaMenu: false,
       showSubcategories: false,
      categories: [], // Example data for categories
      sizes: [], // Example data for sizes
      whereToUse: [], // Example data for where to use
      materials: [], // Example data for materials
      surfaceFinishes: [], // Example data for surface finishes
      colors: [], // Example data for colors
       myModal: null,
      offcanvasInstances: {
        first: null,
        second: null,
        
      },
    };
  },
  methods: {
    toggleOffcanvas(type) {
      const offcanvasRef =
        type === "first" ? this.$refs.offcanvasFirst : this.$refs.offcanvasSecond;

      if (!this.offcanvasInstances[type]) {
        this.offcanvasInstances[type] = new Offcanvas(offcanvasRef);
        console.log(`Offcanvas instance created for: ${type}`);
      }

      this.offcanvasInstances[type].toggle();
    },
     toggleSubcategories() {
      this.showSubcategories = !this.showSubcategories;
    },
    handleOffcanvas() {
    if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
  },
    handleResize() {
      // Automatically close both offcanvas menus on large screens
      if (window.innerWidth > 991) {
        if (this.offcanvasInstances.first) {
          this.offcanvasInstances.first.hide();
        }
        if (this.offcanvasInstances.second) {
          this.offcanvasInstances.second.hide();
        }
      }
    },
     async onMouseEnter() {
      
      this.showMegaMenu = true;
    },
   openModal() {
       if (this.myModal) {
        this.myModal.show();
      }
    },
    async onMouseLeave() {
      clearTimeout(this.megaMenuTimeout);
      this.megaMenuTimeout = setTimeout(() => {
        this.showMegaMenu = false;
      }, 500);
    },
    async onMegaMenuEnter() {
      clearTimeout(this.megaMenuTimeout);
    },
    async onMegaMenuLeave() {
      clearTimeout(this.megaMenuTimeout);
      this.megaMenuTimeout = setTimeout(() => {
        this.showMegaMenu = false;
      }, 500);
    },
     initModal() {
      this.myModal = new Modal(document.getElementById('myModal'));
      
      },
    
    async navigateToHome(path) {
    console.log(path);
    this.$router.push({ path }); // Correct syntax
     if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
},
  
navigateToCategory(category) {
  const path = `/tiles/category/${category.category_id}/${category.category_name}`;
  this.$router.push({ path });

  // ✅ Emit the category selection event
  eventBus.emit("category-selected", category.category_id);

  // ✅ Hide the offcanvas if it's open
  if (this.offcanvasInstances.second) {
    this.offcanvasInstances.second.hide();
  }
},
       
    


     async navigateToSize(size) {

      // Example: Navigate to the 'TilesCategory' route with categoryId and categoryName as parameters
      const path = `/tiles/size/${size.size_id}/${size.size_name}`;
  this.$router.push({ path });
  
  eventBus.emit("size-selected", size.size_id);
   
   if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async navigateToWhereTouse(use){
     const path = `/tiles/WhereTouse/${use.where_to_use_id}/${use.where_to_use_name}`;
  
  // Navigate using the full path
  this.$router.push({ path });
  eventBus.emit("WhereTouse-selected", use.where_to_use_id);
   if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }

    },
    async navigateToMaterial(material){
     const path = `/tiles/material/${material.material_id}/${material.material_name}`;
  
  // Navigate using the full path
  this.$router.push({ path });
  eventBus.emit("material-selected", material.material_id);
   if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async navigateToSurfaceFinish(finish){
     const path = `/tiles/SurfaceFinish/${finish.surface_finish_id}/${finish.surface_finish_name}`;
  
  // Navigate using the full path
  this.$router.push({ path });
   eventBus.emit("SurfaceFinish-selected", finish.surface_finish_id);
   if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async navigateToColor(color){
    const path = `/tiles/color/${color.color_id}/${color.color_name}`;
  
  // Navigate using the full path
  this.$router.push({ path });
  eventBus.emit("color-selected", color.color_id);
   if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async navigateToSanitaryware(path){
    console.log(path);
    this.$router.push({ path }); // Correct syntax
     if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async navigateToFaucet(path){
    this.$router.push({ path }); // Correct syntax
     if (this.offcanvasInstances.second) {
      this.offcanvasInstances.second.hide();
    }
    },
    async fetchData() {
      try {
        const response = await fetch(`${baseURL}/TilesFrontEndController/getcategories`);
        const data = await response.json();
        console.log(data);
        this.categories = data.categories;
        this.sizes = data.size;
        this.whereToUse = data.where_to_use;
        this.materials = data.material;
        this.colors = data.color;
        this.surfaceFinishes = data.surface_finish;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  },
  mounted() {
  this.initModal();
 this.fetchData();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    // Remove resize event listener
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style scoped>
@import './Global.css';
.navbar-custom-light {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.navbar-custom-dark {
    background-color: rgba(15, 3, 182, 0.8);
    position: relative; /* Ensure relative positioning for containing the mega menu */
}
.navbar-dark .navbar-nav .nav-link {
    color: #fff;
    font-size: 16px; /* Matching the base font size */
    margin-right: 20px; /* Spacing between nav items */
  }
  .navbar-dark .navbar-nav .nav-link:hover {
    color: #007BFF;
  }
  .navbar-dark .navbar-nav .nav-link i {
    margin-right: 8px; /* Adding some space between icons and text */
  }
  .nav-item.position-relative:hover .mega-menu {
    display: block; /* Show mega menu on hover */
  }
  
.logo {
    height: 60px;
    width: auto;
}
.navbar-nav .nav-link {
    color: #333;
    font-weight: 500;
    transition: color 0.3s ease;
}

.navbar-nav .nav-link:hover {
    color: #007bff;
}

.nav-item {
    padding: 8px 0;
}
.btn-custom {
    color: #007bff !important;
    border: 1px solid #007bff !important;
    font-weight: 500 !important;
    border-radius: 20px !important;
    padding: 6px 12px !important;
    transition: background-color 0.3s, color 0.3s !important;
}

.btn-custom:hover {
    background-color: #007bff !important;
    color: #fff !important;
}
.mega-menu {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 1200px; /* Set a minimum width to prevent compression */
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: flex;
  border-radius: 10px;
  justify-content: space-between; /* Add spacing between columns */
  border: 1px solid #ddd; /* Subtle border for definition */
}

.mega-menu h5 {
  font-size: 18px; /* Slightly larger headings */
  margin-bottom: 15px; /* More spacing below headings */
  font-weight: 600; /* Bolder heading */
  color: #333; /* Darker color for headings */
  position: relative; /* Relative positioning for pseudo-element */
  display: inline-block;
  padding-right: 10px; /* Adjust space between h5 and red line */
}

.mega-menu h5::after {
  content: '';
  display: block;
  width: 30px; /* Fixed width for the red line */
  height: 2px; /* Fixed height for the red line */
  background-color: darkred; /* Darker red color for the underline */
  position: absolute;
  top: 50%; /* Center vertically relative to the heading */
  left: calc(100% + 5px); /* Adjust space between h5 and red line */
  transform: translateY(-50%); /* Center vertically */
}

.mega-menu-list {
  list-style: none; /* Removing default list styling */
  padding: 0; /* Removing default padding */
  margin: 0; /* Removing default margin */
  border-top: 1px solid #ddd; /* Separator line at the top */
  padding-top: 2px; /* Spacing below the separator line */
}

.mega-menu-list li {
  font-size: 14px; /* Adjust font size */
  color: #333; /* Adjust font color */
  padding: 5px 0; /* Adjust padding */
  border-bottom: 1px solid #ddd; /* Add separator line */
}

.mega-menu-list li:last-child {
  border-bottom: none; /* Remove separator from the last item */
}

.mega-menu-list li:hover {
  text-decoration: underline; /* Underline on hover for better visibility */
  background-color: rgba(0, 123, 255, 0.1); /* Subtle background color change on hover */
  cursor: pointer;
}

/* Separator lines between columns */
.mega-menu .col-md-2 {
  border-right: 1px solid #ddd; /* Separator line color */
  padding-right: 20px; /* Padding to the right of the column */
}

.mega-menu .col-md-2:last-child {
  border-right: none; /* Remove border from the last column */
  padding-right: 0; /* Remove right padding from the last column */
}
.offcanvas {
    background-color: rgba(255, 255, 255, 0.95);
}

/* Offcanvas Header */
.offcanvas-header {
    background-color: #f8f9fa;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.offcanvas-header .navbar-brand .logo {
    height: 51px;
}

.offcanvas-header .btn-close {
    font-size: 1.2rem;
    color: #333;
    opacity: 0.7;
    transition: opacity 0.3s;
}

.offcanvas-header .btn-close:hover {
    opacity: 1;
}

/* Offcanvas Body */
.offcanvas-body {
    padding: 20px;
}

.offcanvas .navbar-nav {
    margin-top: 10px;
}

.offcanvas .navbar-nav .nav-link {
    font-size: 1rem;
    color: #333;
    padding: 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease, color 0.3s ease;
}
.offcanvas .navbar-nav .nav-link {
    font-size: 1rem;
    color: #333;
    padding: 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease, color 0.3s ease;
}
.offcanvas .navbar-nav .nav-link i{
    margin-right:10px;
}
.offcanvas .navbar-nav .nav-link:hover {
    color: #fff;
    background-color: #007bff;
}
.btn-outline-primary {
  border-radius: 20px; /* Rounded buttons */
  padding: 0.5rem 1.5rem;
  transition: all 0.3s ease-in-out;
}

.btn-outline-primary:hover {
  background-color: #007bff; /* Hover effect */
  color: #fff;
}

.text-secondary {
  font-weight: 500;
}
.modal-content {
  border-radius: 12px; /* Rounded corners */
  border: none;
  overflow: hidden; /* Ensures proper rounded corners */
}

.modal-header {
  background-color: #007bff; /* Header color */
  color: #fff; /* White text */
}

.modal-body {
  font-family: "Arial", sans-serif; /* Modern font */
}

/* General Footer Styles */
/* General Footer Styling */
.footer-section {
  /* Replace with your actual background image path */
  background: url('@/assets/final_footer.jpg') no-repeat center center;
  background-size: cover;
  
  /* Adding a semi-transparent overlay for better text contrast */
  position: relative;
  padding: 50px 0;
  color: #ffffff;
}

/* Optional overlay for even better readability */
.footer-section::before {
  content: "";
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 1;
}

.footer-section .container,
.footer-section .row {
  position: relative;
  z-index: 2; /* ensures content is above the overlay */
}

.footer-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  border-bottom: 2px solid #ffa500; /* accent color for underline */
  display: inline-block;
  padding-bottom: 5px;
}

.footer-description {
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 20px;
  color: #f0f0f0;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  font-size: 15px;
  color: #dcdcdc;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: color 0.3s ease;
}

.footer-links a i {
  margin-right: 8px;
  font-size: 16px;
}

.footer-links a:hover {
  color: #ffa500;
}

.footer-contact {
  font-size: 15px;
  line-height: 1.6;
}

.footer-contact a {
  color: #ffa500;
  text-decoration: none;
}

.footer-contact a:hover {
  text-decoration: underline;
}

.footer-social {
  margin-top: 20px;
}

.footer-social .social-icon {
  display: inline-block;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-right: 10px;
  color: #fff;
  border-radius: 50%;
  background: #444;
  transition: background 0.3s ease, color 0.3s ease;
}

.footer-social .social-icon:hover {
  background: #ffa500;
  color: #fff;
}


@media (max-width: 500px) {
   .logo {
    width: 179px;
    height: 51px;
   }
}
@media (max-width: 767px) {
  .footer-section {
    padding: 30px 0;
  }

  .footer-title {
    font-size: 18px;
  }

  .footer-description,
  .footer-links a,
  .footer-contact {
    font-size: 14px;
  }

  .footer-social .social-icon {
    margin-bottom: 5px;
  }
}

</style>
